import { render } from "./newsDetails.vue?vue&type=template&id=5187cbde&scoped=true"
import script from "./newsDetails.vue?vue&type=script&lang=js"
export * from "./newsDetails.vue?vue&type=script&lang=js"

import "./newsDetails.vue?vue&type=style&index=0&id=5187cbde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5187cbde"]])

export default __exports__